import { SidebarGroup } from './sidebar-types';

export const GUIDES_LINKS: SidebarGroup = {
  name: 'Guides',
  children: [
    {
      name: 'Introduction',
      url: 'introduction',
    },

    {
      name: 'Installation',
      url: 'installation',
    },
  ],
};
